module.exports = __webpack_public_path__ + "assets/img/组 11@2x.4013439d.png";